import { useTranslation } from 'react-i18next';
import {
  ExTile,
} from '@boomi/exosphere';
import { useLocation } from 'react-router-dom';
import React from 'react';
import prompts from './PromptExamples.json';
import AgentFoundationPromptExamples from '@common/data/agent-foundation/AgentFoundationPromptExamples.json';
import { useBoomiContext } from '../../context/BoomiContext';

// agent icons
import designGenIcon from '@assets/boomi-ai/ui-kit/agentGarden/designgen-icon.svg';
import answersIcon from '@assets/boomi-ai/ui-kit/agentGarden/answers-icon.svg';
import scribeIcon from '@assets/boomi-ai/ui-kit/agentGarden/scribe-icon.svg';
import pathFindderIcon from '@assets/boomi-ai/ui-kit/agentGarden/pathfinder-icon.svg';
import dataDetectiveIcon from '@assets/boomi-ai/ui-kit/agentGarden/datadetective-icon.svg';

function AgentIcon({ type }: any) {
  let agentIcon;
  if (type === 'designGen') {
    agentIcon = designGenIcon;
  }
  if (type === 'scribe') {
    agentIcon = scribeIcon;
  }
  if (type === 'qna') {
    agentIcon = answersIcon;
  }
  if (type === 'pathfinder') {
    agentIcon = pathFindderIcon;
  }
  if (type === 'datadetective') {
    agentIcon = dataDetectiveIcon;
  }
  return (
    <div>
      {agentIcon && (
      <div>
        <img className="agent-icon" src={agentIcon} alt="agent icon" />
      </div>
      )}
    </div>
  );
}

function BoomiAIPrompts({
  enterText, darkMode, methodResponse, disableInteraction,
}: any) {
  const {
    setInputText,
  } = useBoomiContext();
  const location = useLocation();
  const [t] = useTranslation('common');
  const isAgentFoundation = location.pathname.includes('home');

  return (
    <div className="prompt-examples">
      { !isAgentFoundation && prompts?.length > 0
          && (
          <div className="prompt-examples__title">
            <span className="prompt-examples__title__text">
              {t('ai_prompt_examples_text')}
            </span>
          </div>
          )}
      { !isAgentFoundation && prompts?.length > 0
          && (
          <div className="prompt-examples__intents">
            {prompts.map((prompt) => (
              <button
                type="button"
                key={prompt.id}
                tabIndex={0}
                className="prompt-examples__intents__text ex-col-lg-4 tile-button"
                aria-label={prompt.ai_prompt_example}
                onClick={(e) => {
                  enterText(prompt.ai_prompt_example, '', prompt.type);
                  methodResponse.current = 'Pre-canned';
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    enterText(prompt.ai_prompt_example, '', prompt.type);
                    methodResponse.current = 'Pre-canned';
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                <ExTile
                  className={`${darkMode ? 'prompt-examples__intents__text__list dark' : 'prompt-examples__intents__text__list'}`}
                  title={prompt.ai_prompt_example}
                  label={prompt.ai_prompt_example}
                  describedby={prompt.ai_prompt_example}
                >
                  <AgentIcon type={prompt.type} />
                  <div className="prompt-container">{prompt.ai_prompt_example}</div>
                </ExTile>
              </button>
            ))}
          </div>
          )}
      { isAgentFoundation && AgentFoundationPromptExamples?.length > 0
          && (
            <div className="suggestion-pills-section">
              <div className="suggestions-title">{t('homepage_examples_to_try')}</div>
              <div className="suggestion-pills-grid">
                <div className="suggestion-pill-row">
                  {AgentFoundationPromptExamples.map((prompt) => (
                    <button
                      key={prompt.id}
                      type="button"
                      className="suggestion-pill"
                      disabled={disableInteraction}
                      onClick={(e: any) => {
                        if (!disableInteraction) {
                          setInputText(prompt.input_text);
                          e.stopPropagation();
                        }
                      }}
                      data-testid={`boomi-gpt-prompt-${prompt.id}`}
                    >
                      <span className="pill-text">{prompt.ai_prompt_example}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
    </div>
  );
}

export default BoomiAIPrompts;
